var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0.18 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-coverage_svg__Icon_-_Coverage",
    "data-name": "Icon - Coverage",
    transform: "translate(.75 .932)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-coverage_svg__Path_4021",
    "data-name": "Path 4021",
    d: "M13.045 14.137l-3.712.531.53-3.713 9.546-9.546a2.25 2.25 0 013.182 3.182z",
    transform: "translate(-.75 -.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-coverage_svg__Line_380",
    "data-name": "Line 380",
    transform: "translate(17.598 1.72)",
    d: "M0 0l3.182 3.182"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-coverage_svg__Path_4022",
    "data-name": "Path 4022",
    d: "M18.75 14.251v7.5a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5v-15a1.5 1.5 0 011.5-1.5h7.5",
    transform: "translate(-.75 -.75)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMC4xOCAyNCAyNCI+CiAgPGcgaWQ9Ikljb25fLV9Db3ZlcmFnZSIgZGF0YS1uYW1lPSJJY29uIC0gQ292ZXJhZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNzUgMC45MzIpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzQwMjEiIGRhdGEtbmFtZT0iUGF0aCA0MDIxIiBkPSJNMTMuMDQ1LDE0LjEzN2wtMy43MTIuNTMxLjUzLTMuNzEzLDkuNTQ2LTkuNTQ2YTIuMjUsMi4yNSwwLDAsMSwzLjE4MiwzLjE4MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjc1IC0wLjc1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzM4MCIgZGF0YS1uYW1lPSJMaW5lIDM4MCIgeDI9IjMuMTgyIiB5Mj0iMy4xODIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3LjU5OCAxLjcyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzQwMjIiIGRhdGEtbmFtZT0iUGF0aCA0MDIyIiBkPSJNMTguNzUsMTQuMjUxdjcuNWExLjUsMS41LDAsMCwxLTEuNSwxLjVoLTE1YTEuNSwxLjUsMCwwLDEtMS41LTEuNXYtMTVhMS41LDEuNSwwLDAsMSwxLjUtMS41aDcuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuNzUgLTAuNzUpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgIconCoverage as ReactComponent };